import { render, staticRenderFns } from "./UserTabConnections.vue?vue&type=template&id=4099dcf0"
import script from "./UserTabConnections.vue?vue&type=script&lang=js"
export * from "./UserTabConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports